import React from 'react';

import { PowerBIEmbed } from 'powerbi-client-react';
import { useTranslation } from 'react-i18next';

interface ReportContentProps {
  useFallback: boolean;
  fallbackUrl: string | null;
  embedConfig: any;
  hasEncryption: boolean;
  isAuthenticated: boolean;
  onEmbedError: () => void;
}

const ReportContent: React.FC<ReportContentProps> = ({
  useFallback,
  fallbackUrl,
  embedConfig,
  hasEncryption,
  isAuthenticated,
  onEmbedError,
}) => {
  const { t } = useTranslation();

  if (useFallback && fallbackUrl) {
    return (
      <iframe
        src={fallbackUrl}
        style={{ width: '100%', height: '100%', border: 'none' }}
        allow="fullscreen"
        title={t('scenes.power_bi_report.iframe.fallback_title')}
      />
    );
  }

  if (embedConfig) {
    return (
      <PowerBIEmbed
        embedConfig={embedConfig}
        cssClassName="powerbi-container"
        eventHandlers={
          new Map<string, (event?: any) => void>([['error', onEmbedError]])
        }
      />
    );
  }

  if (hasEncryption && !isAuthenticated) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <p>{t('scenes.power_bi_report.messages.waiting_authentication')}</p>
      </div>
    );
  }

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <p>{t('scenes.power_bi_report.messages.loading_report')}</p>
    </div>
  );
};

export default ReportContent;
